import React from "react";
import { useParams, Redirect } from "react-router-dom";

// this page is simply used to extract the id from the url
export const ViewMessage = () => {
  const { id } = useParams<{ id: string }>();

  return <Redirect to={`/list/${id}`} />;
};
